// extracted by mini-css-extract-plugin
export var active = "Navbar-module--active--694c5";
export var hamburger = "Navbar-module--hamburger--b85d2";
export var home = "Navbar-module--home--c2127";
export var items = "Navbar-module--items--efbaa";
export var navbar = "Navbar-module--navbar--5851a";